import * as React from "react";
import { forwardRef } from "react";
const CheckSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M21.678 5.265a1 1 0 0 1 .057 1.413l-12 13a1 1 0 0 1-1.36.103l-5-4a1 1 0 0 1 1.25-1.562l4.272 3.418L20.265 5.322a1 1 0 0 1 1.413-.057", clipRule: "evenodd" }));
const ForwardRef = forwardRef(CheckSVG);
export default ForwardRef;
//# sourceMappingURL=Check.js.map